export default class Buttons {
	static init() {
		this.buttons = document.querySelectorAll(".btn, .btn-fill, .btn-stroke");

		this.buttons.forEach( (button) => {

			const text = `<span class='label'>${button.innerHTML}</span>`;
			button.innerHTML = text;

			if( button.classList.contains('btn-go') || button.classList.contains('btn-back') ){
				const element = document.createElement("span");
				element.innerHTML = `<svg width="15" height="11" viewBox="0 0 15 11" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M9.13178 0.767781C9.32704 0.572519 9.64363 0.572519 9.83889 0.767781L14.0815 5.01042C14.2768 5.20568 14.2768 5.52227 14.0815 5.71753L9.83889 9.96017C9.64363 10.1554 9.32704 10.1554 9.13178 9.96017C8.93652 9.76491 8.93652 9.44832 9.13178 9.25306L12.5209 5.86398H1.00005C0.72391 5.86398 0.500053 5.64012 0.500052 5.36398C0.500053 5.08783 0.72391 4.86398 1.00005 4.86398L12.5209 4.86398L9.13178 1.47489C8.93652 1.27963 8.93652 0.963044 9.13178 0.767781Z" fill="currentColor"/>
</svg>`;
				element.classList.add('svg');
				button.appendChild(element);
			}

			if( button.classList.contains('btn-download') ){
				const element = document.createElement("span");
				element.innerHTML = `<svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.51223 5.64288L0.5 6.63552L7.5 13.5L14.5 6.63552L13.488 5.64288L8.21598 10.8129L8.21598 0.5L6.78441 0.5L6.78441 10.8129L1.51223 5.64288Z"/>
<path d="M2 15H13V16H2V15Z"/>
</svg>`;
				element.classList.add('svg');
				button.appendChild(element);
			}

			if( button.classList.contains('btn-gallery') ){
				const element = document.createElement("span");
				element.innerHTML = `<svg width="17" height="14" viewBox="0 0 17 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4 1H16V10M1 4H13V13H1V4Z" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;
				element.classList.add('svg');
				button.appendChild(element);
			}

			if( button.classList.contains('btn-lang') ){
				const element = document.createElement("span");
				element.innerHTML = `<svg width="15" height="10" viewBox="0 0 15 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.08786 0.982932L8.15892 8.054L7.07107 9.14186L0 2.07079L1.08786 0.982932Z" fill="#34847A"/>
<path d="M14.1422 2.07077L7.07107 9.14186L5.98332 8.05398L13.0544 0.98291L14.1422 2.07077Z" fill="#34847A"/>
</svg>`;
				element.classList.add('svg');
				button.appendChild(element);
			}

		});
	}
}
